var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'd-flex maxw-100 p-2 gmb-notification-cell',
    { 'gmb-notification-cell--long': _vm.noLength },
    { 'gmb-notification-cell--placeholder': _vm.isPlaceholder },
    { 'align-items-center rounded-1': !_vm.isPlaceholder },
    { 'gmb-notification-cell--error': _vm.isError },
    { 'gmb-notification-cell--info': _vm.isInfo },
    { 'gmb-notification-cell--success': _vm.isSuccess },
  ]},[(!_vm.isPlaceholder)?[_c('div',{staticClass:"d-flex flex-grow-1 w-0 flex-column"},[_c('FdText',{staticClass:"gmb-notification-cell__message",attrs:{"tag":"span"}},[_vm._v(_vm._s(_vm.message)+" ")])],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }